export const parseOAuthHash = (win = window) => {
  const hash = win.location.hash;
  if (!hash || hash.length <= 1) {
    return null;
  }

  const params = new URLSearchParams(hash.substring(1));
  const accessToken = params.get('access_token');
  const error = params.get('error');

  if (!accessToken && !error) {
    return null;
  }

  return { accessToken, error };
};

export const clearOAuthHash = (win = window) => {
  if (!win.location.hash) {
    return;
  }

  win.history.replaceState(
    null,
    null,
    win.location.pathname + win.location.search
  );
};

export const OAUTH_ERROR_MESSAGE =
  'No se pudo completar el ingreso. Intentá nuevamente o usá otra forma de acceso.';
